module.exports = __webpack_public_path__ + "img/search-img.4dc1dee7.svg";